import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { CustomerOverviewComponent } from './customer-overview/customer-overview.component';
import { UserManagementComponent } from './user-management/user-management.component';

@NgModule({
  declarations: [UserManagementComponent, CustomerOverviewComponent],
  imports: [
    CommonModule,
    I18nModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ConfigModule.withConfig({
      cmsComponents: {
        UserManagementListComponent: {
          component: UserManagementComponent,
        },
        CustomerDetailsComponent: {
          component: CustomerOverviewComponent,
        },
      },
    } as CmsConfig),
    FontAwesomeModule,
  ],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class UserAccessManagementModule {}
